'use client';

import { useAccount, useMsal } from '@azure/msal-react';

export function useActiveAccount() {
  const { accounts } = useMsal();

  return useAccount(accounts[0] || {});
}
